import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { SyntheticEvent, useEffect, useState } from "react";
import Spinner from "../../../../../reusableComponents/spinner/spinner";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks/hooks";

import { enableClient } from "../../../../../../store/thunks/systemManagementThunk";

interface EnableClientDialogProps {
  open: any;
  handleEnableClientClose: any;
  enableClientData: any;
}

const EnableClientDialog = (props: EnableClientDialogProps) => {
  const dispatch = useAppDispatch();
  const { open, handleEnableClientClose, enableClientData } = props;

  const { addClientLoading } = useAppSelector(
    (state: any) => state.systemManagement
  );

  const [enableClientError, setEnableClientError] = useState(false);
  const [enableClientErrorMessage, setEnableClientErrorMessage] = useState("");

  const handleEnableClient = (message: string, reason?: any) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    handleEnableClientClose(message);
  };

  const submitEnableClient = () => {
    dispatch(
      enableClient({ client_index: enableClientData?.client_index })
    ).then((result: any) => {
      if (result.payload.result === true) {
        handleEnableClient(result.payload.message);
      } else {
        setEnableClientError(true);
        setEnableClientErrorMessage(result.payload.message);
      }
    });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      onClose={(event, reason) => handleEnableClient("", reason)}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(59, 147, 74, 1)",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "white" }}>
          Enable Client
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => handleEnableClient("")}
          sx={{
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Spinner loading={addClientLoading} />
      <DialogContent>
        <DialogContentText>
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center", padding: "10px" }}
          >
            Are you sure that you want to enable Client:{" "}
            <span style={{ fontWeight: "bold" }}>
              {enableClientData?.customer_name}
            </span>
            , Customer ID :{" "}
            <span style={{ fontWeight: "bold" }}>
              {enableClientData?.customer_id}
            </span>
          </Grid>
          {enableClientError && (
            <Grid
              container
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Typography sx={{ color: "red" }}>
                {enableClientErrorMessage}
              </Typography>
            </Grid>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid" }}>
        <Button
          variant="outlined"
          onClick={() => handleEnableClient("")}
          sx={{
            padding: "5px 10px 5px 10px",
            backgroundColor: "red",
            color: "black",
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="outlined"
          sx={{
            padding: "5px 10px 5px 10px",
            backgroundColor: "rgba(59, 147, 74, 1)",
            color: "white",
          }}
          onClick={() => submitEnableClient()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnableClientDialog;
